import { ApiError, type ApiErrorBody } from '../models/common';

type UnauthorizedHandler = () => void;

/**
 * Tek HTTP kapısı. Oturum httpOnly cookie ile taşınır (JS tarafında token
 * tutulmaz). 401 gelirse kayıtlı handler (login'e yönlendirme) tetiklenir.
 */
class ApiClient {
  private onUnauthorized: UnauthorizedHandler | null = null;

  setUnauthorizedHandler(fn: UnauthorizedHandler): void {
    this.onUnauthorized = fn;
  }

  async get<T>(path: string): Promise<T> {
    return this.request<T>('GET', path);
  }

  async post<T>(path: string, body?: unknown): Promise<T> {
    return this.request<T>('POST', path, body);
  }

  async put<T>(path: string, body?: unknown): Promise<T> {
    return this.request<T>('PUT', path, body);
  }

  async delete<T>(path: string): Promise<T> {
    return this.request<T>('DELETE', path);
  }

  private async request<T>(method: string, path: string, body?: unknown): Promise<T> {
    const res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? undefined : { 'content-type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });

    if (res.status === 401) {
      this.onUnauthorized?.();
    }
    if (!res.ok) {
      let errBody: ApiErrorBody | null = null;
      try {
        errBody = (await res.json()) as ApiErrorBody;
      } catch {
        /* gövde JSON değilse status yeter */
      }
      throw new ApiError(res.status, errBody);
    }
    if (res.status === 204) return undefined as T;
    return (await res.json()) as T;
  }
}

export const api = new ApiClient();

/** Panel API kök yolu — nginx'te FastAPI'ye proxylenir. */
export const PANEL_API = '/panel/api';
